import styled from 'styled-components';
import Text from '@text';
import styleUtils from '../../../../styles/style.utils';
import themedColor from '../../../../styles/theme/themed-color';
import themedFontSize from '../../../../styles/theme/themed-font-size';
import mediaBreakpoints from '../../../../styles/media-breakpoints';

const Container = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: ${styleUtils.px(18)};
  flex-direction: column-reverse;

  ${mediaBreakpoints.greaterThan('M')`    
    flex-direction:row;
  `};
`;

const Description = styled.div`
  color: ${themedColor('TEXT_BLUE')};
  font-size: ${themedFontSize('ATTACHMENT_DESC')};
  font-weight: 600;
  padding-right: ${styleUtils.px(16)};
  display: flex;
  align-items: center;
  margin-top: ${styleUtils.px(8)};
  text-align: justify;

  p {
    color: ${themedColor('TEXT_BLUE')};
    font-size: ${themedFontSize('ATTACHMENT_DESC')};
    font-weight: 600;
  }

  ${mediaBreakpoints.greaterThan('M')` 
    margin-top:0;   
    flex-basis: 50%;
  `};
`;

const InputContainer = styled.div`
  max-width: ${styleUtils.size('MAX_CONTAINER_WIDTH')};

  ${mediaBreakpoints.greaterThan('M')`   
    max-width:50%; 
    flex-basis: 50%;
  `};
`;

const InputZone = styled.div`
  max-width: 100%;
  position: relative;
  height: ${styleUtils.size('INPUT_HEIGHT')};
  background: ${themedColor('INPUT_BG')};
  border: 1px solid ${themedColor('INPUT_BORDER')};
  border-radius: 21px;
  padding: 0 ${styleUtils.px(16)};
  min-width: ${styleUtils.size('MIN_INPUT_WIDTH')};
  width: 100%;
  color: ${themedColor('TEXT_BLUE')};
  font-size: ${themedFontSize('FORM')};
  font-weight: 400;
  justify-content: center;
  align-items: center;
  display: flex;
  cursor: pointer;

  &:focus {
    outline: 0;
    border-color: ${themedColor('INPUT_FOCUS_BORDER')};
  }

  &:hover {
    outline: 0;
    border-color: ${themedColor('INPUT_FOCUS_BORDER')};
  }
`;

const HiddenInput = styled.input`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
  width: 100%;
  cursor: pointer;
`;

const StyledText = styled(Text)`
  &.ucf-paragraph {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    line-height: ${styleUtils.px(32)};
    margin-bottom: 0;
  }
`;

const FormFileUploadComponents = {
  Container,
  Description,
  InputContainer,
  HiddenInput,
  InputZone,
  StyledText
};

export default FormFileUploadComponents;
